module.exports = __webpack_public_path__ + "img/function_03.1ff8a896.png";